import { createStore, combineReducers, compose, applyMiddleware } from "redux";
import thunk from "redux-thunk";
/**
 * *NOTA: Importan los patos
 */
import paquetesReducer from "./paqueteDuck";
import vuelosReducer from "./vueloDuck";
import hotelesReducer from "./hotelDuck";
import habitacionesReducer from "./habitacionDuck";
import extrasReducer from "./extrasDuck";
import salidasReducer from "./salidasDuck";
import logeoReducer from "./logeoDuck";
import catalogoCiudadReducer from "./catalogoCiudadDuck";
import proveedorReducer from "./proveedorDuck";
import proveedorUsuarioReducer from "./porveedorUsuarioDuck";
import usuariosReducer from "./usuariosDuck";
import viajeCalendarioReducer from "./viajeCalendarioDuck";
import rolesReducer from "./rolDuck";
import pagoUnicoReducer from "./pagoUnicoDuck";
import pagosReducer from "./pagosDuck";
import pagosMasivosReducer from "./pagosMasivosDuck";
import PaquetesImagenNReducer from "./paqueteImagenDuck";
import cotizacionReducer from "./cotizacionDuck";
import clientesReducer from "./clientesDuck";
import paqueteDetallleReducer from "./paqueteDetalleDuck";
import finanzasReducer from "./finanzasDuck";
import cambiosReducer from "./cambiosDuck";
import cambiosPaqueteReducer from "./cambioPaqueteDuck";
import reservasReducer from "./reservasDuck";
import reservasExpiradasReducer from "./reservasExpiradasDuck";
import reservasAutorizadasReducer from "./reservasAuthDuck";
import aereosReducer from "./aereosDuck";
import aereosAutorizadasReducer from "./aereosAuthDuck";
import liquidacionesReducer from "./liquidacionesDuck";
import liquidacionesAutorizadasReducer from "./liquidacionesAuthDuck";
import cambiosClaveViajeReducer from "./cambiosClaveViaje";
import voucherIndividualReducer from "./voucherIndividualDuck";
import voucherGrupalReducer from "./voucherGruapalDuck";
import loadReducer from "./loadDuck";
import cotizadorReducer from "./cotizadorDuck";
import cotizadorPaqueteReducer from "./cotizadorPaqueteDuck";
import bancoReducer from "./bancoDuck";
import bancoMainReducer from "./bancoGeneralDuck";
import reportesReducer from "./reportesDuck";
import devolucioenesPendientesReducer from "./devolucionesDuck";
import cotizacionesReducer from "./cotizacioensDuck";
import devolucioenesAceptadasReducer from "./devolucionesAceptadas";
import devolucioenesHistoriaReducer from "./devolucionesHistorial";
import facturasPendientesReducer from "./facturacionRecienteDuck";
import facturacionAceptadasReducer from "./facturacionAceptadasDuck";
import facturacionHistoriaReducer from "./facturacionHistorialDuck";
import extrasContratadosReducer from "./ExtrasContratadosDuck";
import extrasContratadosAceptadasReducer from "./extrasContratadosAceptadasDuck";
import extrasContratadosHistorialReducer from "./extrasContratadosHistorialDuck";
import landingReducer from "./landingDuck";
import reportesCotizacionesReducer from "./reportesCotizacionesDuck";
import reporteClientesReducer from "./reporteClientesDuck";
import ofertasPaqueteReducer from "./ofertasPaqueteDuck";
//* Metodos nuevo flujo del mayorista 
import proveedorTerrestreReducer from "./proveedorTerrestreDuck";
import vueloProveedorReducer from "./proveedorAereolineaDuck";
import proveedorMayoristaReducer from "./proveedorMayoristaDuck"
/**
 * *Nota: Se añade los paratos al reducer
 */
const rootReduce = combineReducers({
    paquetes: paquetesReducer,
    paqueteDetalle: paqueteDetallleReducer,
    vuelos: vuelosReducer,
    hoteles: hotelesReducer,
    habitaciones: habitacionesReducer,
    extras: extrasReducer,
    salidas: salidasReducer,
    logeo: logeoReducer,
    catalogoCiudad: catalogoCiudadReducer,
    proveedores: proveedorReducer,
    proveedoresUsuarios: proveedorUsuarioReducer,
    usuarios: usuariosReducer,
    calendario: viajeCalendarioReducer,
    roles: rolesReducer,
    pagoUnico: pagoUnicoReducer,
    pagos: pagosReducer,
    pagosMasivos: pagosMasivosReducer,
    paquetesImagen: PaquetesImagenNReducer,
    cliente: clientesReducer,
    cotizacion: cotizacionReducer,
    finanzas: finanzasReducer,
    cambios: cambiosReducer,
    cambiosPaquete: cambiosPaqueteReducer,
    reservas: reservasReducer,
    reservasExpirdas: reservasExpiradasReducer,
    reservasAuth: reservasAutorizadasReducer,
    aereos: aereosReducer,
    aereosAuth: aereosAutorizadasReducer,
    liquidaciones: liquidacionesReducer,
    liquidacionesAuth: liquidacionesAutorizadasReducer,
    cambiosGrupales: cambiosClaveViajeReducer,
    vouchersIndividual: voucherIndividualReducer,
    vouchersGrupal: voucherGrupalReducer,
    load: loadReducer,
    cotizador: cotizadorReducer,
    cotizadorPaquete: cotizadorPaqueteReducer,
    banco: bancoReducer,
    bancoMain: bancoMainReducer,
    reportes: reportesReducer,
    devolucionesPendientes: devolucioenesPendientesReducer,
    devolucionesAceptadas: devolucioenesAceptadasReducer,
    devolucionesHistorial: devolucioenesHistoriaReducer,
    cotizaciones: cotizacionesReducer,
    facturasPendientes:  facturasPendientesReducer,
    facturasAceptadas: facturacionAceptadasReducer,
    facturasHistorial: facturacionHistoriaReducer,
    extrasContratados: extrasContratadosReducer,
    extrasContratadosAprobados: extrasContratadosAceptadasReducer,
    extrasContratadosHistorial: extrasContratadosHistorialReducer,
    landing: landingReducer,
    reporteCotizador: reportesCotizacionesReducer,
    proveedorTerrestre: proveedorTerrestreReducer,
    vueloProveedor: vueloProveedorReducer,
    proveedorMayorista: proveedorMayoristaReducer,
    reporteClientes: reporteClientesReducer,
    ofertasPaquete: ofertasPaqueteReducer,
});

/**
 * *Nota: Se configura pluging para el navegador
 * !Importante: Eliminar "window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__" para productivo
 */
const composeEnhancers = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__|| compose;

/**
 * @store
 */
export default function generateStore() {
    const store = createStore(rootReduce, composeEnhancers(applyMiddleware(thunk)));
    return store;
}